var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_c('v-progress-circular',{attrs:{"size":"70","width":"7","color":"purple","indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }